import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rd-card',
  template: `<div class="rdCard">
  <ng-content></ng-content>
</div>
`,
  styles: [`.rdCard{width:100%;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12)}`]
})
export class RDCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
